module.exports = __webpack_public_path__ + "static/logo-liquid-24fe937ec0869182bec9a773d905d735.svg";